import { modalActionType } from '../../actionTypes';
import { modalType } from '../onModalAction/actionType';

export const onLimitCheck = (lenderId, lenderLogo, userMobileNum) => (
  dispatch,
) => {
  dispatch({
    type: modalActionType.SHOW_MODAL,
    payload: {
      modalType: modalType.limitCheckDetailsModal,
      info: { lenderId, lenderLogo, userMobileNum },
    },
  });
};

export const closeLimitCheckModal = () => (dispatch) => {
  dispatch({
    type: modalActionType.HIDE_MODAL,
    payload: {
      modalType: modalType.limitCheckDetailsModal,
      info: {},
    },
  });
};



// WEBPACK FOOTER //
// ./actions/onLimitCheck/index.js